import ImageTwo from "../../Images/img-2.jpg";
import ImageThree from "../../Images/img-11.jpg";
import ImageFour from "../../Images/img-8.jpg";
import ImageFive from "../../Images/img-2.jpg";

export const SliderData = [
    {
        title: "Best Technology Company",
        text: "We are one of the best technology company in the world",
        path: "/homes",
        label: "View Home",
        image: (`${ImageTwo}`),
        alt: "House"
    },

    {
        title: "Great Customer Service",
        text: "We are live 24/7, your welfare is our concern",
        path: "/homes",
        label: "Contact Us",
        image: (`${ImageThree}`),
        alt: "House"
    },

    {
        title: "Join Our growing community",
        text: "Sign Up and join our ever growing community of satisfied customers",
        path: "/signup",
        label: "Sign Up",
        image: (`${ImageFour}`),
        alt: "House"
    },

    {
        title: "Conducive Environment",
        text: "$3,200,000",
        path: "/homes",
        label: "Conducive",
        image: (`${ImageFive}`),
        alt: "House"
    },
]